import styled from "styled-components";
import { Col, Row } from "@vds/grids";
import { Modal } from "@vds/modals";
import { Notification } from "@vds/notifications";
import { Wrapper } from "./StyledGlobalConstants";
import { Button } from "@vds/buttons";

export const TableWrapper = styled.table`
  margin-top: 1.5rem;
  margin-bottom: 0.5rem !important;
  width: ${(props) => (props.width ? props.width : "100%")};
`;

export const TableHeaderContainer = styled.tr`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 0.875rem;
  font-family: neue-haas-grotesk-text;
  line-height: 1rem;
  vertical-align: inherit;
  padding: 0.5rem 0rem 0.75rem 0;
  font-weight: bold;
  border-bottom: 4px solid #000000;
  @media (min-width: 768px) and (max-width: 1439px) {
    align-items: flex-start;
    height: 3.5rem;
    padding: 12px 0;
    border-top: 2px solid #000000;
    border-bottom: 1px solid #000000;
    font-family: neue-haas-grotesk-text;
  }
  @media (min-width: 1440px) {
    align-items: center;
    height: 3.5rem;
    padding: 0;
    border-top: 2px solid #000000;
    border-bottom: 1px solid #000000;
    font-family: neue-haas-grotesk-text;
  }

  div {
    width: 10%;
  }

  .icon-wrapper {
    width: 9%;
  }

  .form-wrapper {
    width: 6%;
  }

  @media (max-width: 767px) {
    justify-content: left;
    font-size: 10px;
  }
`;

export const TableBodyContainer = styled.tr`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem 0 0.5rem 0;
  font-size: 0.75rem;
  font-weight: 400;
  font-family: neue-haas-grotesk-text;
  vertical-align: inherit;
  line-height: 1rem;
  border-bottom: 1px solid #000000;

  &:last-child {
    border-bottom: none;
  }
  .form-wrapper {
    width: 6%;
  }

  .icon-wrapper {
    width: 9%;
  }
  @media (max-width: 1023px) {
    font-size: 10px;
  }
  @media (min-width: 1024px) {
    border-bottom: 1px solid #d8dada;
    font-family: neue-haas-grotesk-text;
    height: auto;
    padding: 13px 0px;
  }
  @media (min-width: 1440px) {
    border-bottom: 1px solid #d8dada;
    font-family: neue-haas-grotesk-text;
    height: 3rem;
    padding: 0px;
  }
`;

export const PaymentTableContainer = styled.tr`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0 0.5rem 0;
  font-size: 0.875rem;
  font-weight: 400;
  font-family: neue-haas-grotesk-text;
  vertical-align: inherit;
  line-height: 1rem;
  border-bottom: 1px solid #000000;

  &:last-child {
    border-bottom: none;
  }
  .form-wrapper {
    width: 6%;
  }

  .icon-wrapper {
    width: 14%;
  }
  @media (max-width: 1023px) {
    font-size: 10px;
  }

  @media (min-width: 1024px) {
    border-bottom: 1px solid #d8dada;
    font-family: neue-haas-grotesk-text;
    height: 3rem;
    padding: 0rem;
  }
`;

export const AccountTableHeaderContainer = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  line-height: 1rem;
  vertical-align: inherit;
  padding: 0.5rem 0rem 0.75rem 0;
  font-weight: bold;
  border-bottom: 4px solid #000000;

  div {
    width: 15%;
  }

  .icon-wrapper {
    width: 14%;
  }

  .form-wrapper {
    width: 6%;
  }
`;
export const AccountTableBodyContainer = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 0 1rem 0;
  font-size: 14px;
  font-weight: 400px;
  font-family: neue-haas-grotesk-text;
  vertical-align: inherit;
  line-height: 1rem;
  border-bottom: 1px solid #000000;

  &:last-child {
    border-bottom: none;
  }
  div {
    width: 15%;
    overflow-wrap: break-word;
  }
  .form-wrapper {
    width: 6%;
  }

  .icon-wrapper {
    width: 14%;
  }
`;

export const TableActionWrapper = styled.div`
  span {
    color: rgb(45, 151, 238);
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: rgb(45, 151, 238);
    padding-right: 15px;
    margin-top: 5px;
  }
`;

export const TableActionWrapperSpan = styled.div`
  span {
    font-weight: bold;
    padding-right: 15px;
    margin-top: 5px;
  }
`;

export const TableActionWrapperToggle = styled.div`
  span {
    color: #fffff;
    padding-right: 50px;
    margin-top: 5px;

    :: after {
      content: "";
    }

    :: before {
      content: "";
    }
  }
`;

export const ContactTableWrapper = styled.table`
  margin-top: 1rem;
  margin-bottom: 0.5rem !important;
  width: 75%;
  @media (min-width: 1024px) {
    width: 100%;
  }
  @media (max-width: 1439px) {
    width: 100%;
  }
`;

export const ContactTableHeaderContainer = styled.tr`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 14px;
  font-family: neue-haas-grotesk-text;
  line-height: 1rem;
  vertical-align: inherit;
  padding: 1rem 0rem 1rem 0;
  font-weight: bold;
  border-bottom: 4px solid #000000;

  @media (min-width: 679px) {
    border-top: 2px solid #000000;
    border-bottom: 1px solid #000000;
    padding-right: 8px;
    padding-left: 24px;
  }

  div {
    width: 10%;
  }

  .icon-wrapper {
    width: 14%;
  }

  .form-wrapper {
    width: 6%;
  }
`;

export const ContactTableBodyContainer = styled.tr`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  // padding: 1rem 0 1rem 0;
  font-size: 14px;
  font-weight: 400px;
  font-family: neue-haas-grotesk-text;
  vertical-align: inherit;
  line-height: 1rem;
  border-bottom: 1px solid #000000;

  @media (min-width: 679px) {
    font-family: neue-haas-grotesk-text;
    font-size: 12px;
    font-weight: 400;
    line-height: 18px;
    border-bottom: 1px solid #d8dada;
    padding-right: 8px;
    padding-left: 24px;
  }

  &:last-child {
    border-bottom: none;
    @media (min-width: 679px) {
      border-bottom: 1px solid #d8dada;
    }
  }
  .form-wrapper {
    width: 6%;
  }

  .icon-wrapper {
    width: 14%;
  }
`;

export const CustomWrapper = styled(Wrapper)`
  display: flex;
  flex-direction: row;
  @media (min-width: 768px) and (max-width: 1023px) {
    flex-wrap: nowrap;
  }
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 1rem;
  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: "";
    width: 100%;
    // margin-top: 0.5rem;
  }
  @media (min-width: 767px) and (max-width: 1023px) {
    justify-content: flex-start;
    align-items: center;
  }
`;

export const DateWrapper = styled(Wrapper)`
  display: flex;
  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    & input {
      width: 100%;
    }
  }
  @media (min-width: 481px) and (max-width: 679px) {
    width: 60vw;
    & input {
      width: 90%;
    }
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: right;
  @media (max-width: 767px) {
    width: 100%;
  }
  @media (min-width: 1024px) {
    flex-direction: column;
    justify-content: flex-start;
  }
`;

export const AccordianDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 0 0.5rem 0;
  // @media (min-width: 680px) {
  //   width: 100%;
  // }
`;

export const AccordianSpanHeader = styled.span`
  font-size: 0.75rem;
  font-family: neue-haas-grotesk-text;
  color: #000000;
  font-weight: bold;
  width: 40%;
  margin-right: 0.625rem;
  // @media (min-width: 430px) {
  //   width: 45%;
  // }
  @media (min-width: 1024px) {
    font-family: neue-haas-grotesk-text;
    font-size: 0.875rem;
  }
`;

export const AccordianSpanBody = styled.span`
  font-size: 0.75rem;

  @media (max-width: 1023px) {
    font-size: 0.75rem;
  }
  font-family: neue-haas-grotesk-text;
  color: #000000;
  width: 60%;
  // @media (min-width: 430px) {
  //   width: 55%;
  // }
  @media (min-width: 1024px) {
    font-size: 0.875rem;
    font-family: neue-haas-grotesk-text;
  }
`;

export const ErrorNotification = styled(Notification)`
  position: absolute !important;
  z-index: 1;
  margin-top: auto;
  max-width: 100% !important;
  width: 92% !important;
  @media (min-width: 1024px) {
    width: 75% !important;
    & div {
      & div {
        max-width: 100% !important;
      }
    }
  }
`;

export const CustomModal = styled(Modal)`
  height: 14.75rem !important;
  width: 35rem !important;
  @media (max-width: 767px) {
    min-height: 14.75rem !important;
    & .modalBodyPaddingTop {
      padding-top: 1.75rem !important;
    }
  }
  @media (max-width: 679px) {
    width: 90% !important;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  button {
    margin: 12px 16px 16px;
  }
  @media (max-width: 768px) {
    button {
      justify-content: center;
    }
  }
`;

export const StyledDateDiv = styled.div`
  @media (max-width: 480px) {
    width: 100%;
    margin-bottom: 1rem;
  }
  @media (min-width: 481px) and (max-width: 679px) {
    width: 49.8%;
  }
`;

export const StyledApplyButton = styled(Button)`
  height: ${(props) => (props.height ? props.height : "")};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "")};
  width: ${(props) => (props.width ? props.width : "")};
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
`;

export const LeftAlignedCol = styled(Col)`
  font-family: neue-haas-grotesk-text;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
  min-width: 50%;
`;
export const RightAlignedCol = styled(Col)`
  font-family: neue-haas-grotesk-text;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const StyledRow = styled(Row)`
  margin-top: 8px;
`;
